import React from 'react'
import { Channel, Group } from '~/models'
import { memo } from '~/ui/component'
import { Label, VBox } from '~/ui/components'
import { useBoolean } from '~/ui/hooks'
import { useResourceTranslation } from '~/ui/resources'
import { ResourceChipRow } from '~/ui/resources/components'
import { SummaryInfo } from '~/ui/resources/detail'
import { layout } from '~/ui/styling'
import ChannelModerationForm from './ChannelModerationForm'

export interface Props {
  channel: Channel
}

const ChannelModeration = memo('ChannelModeration', (props: Props) => {

  const {channel} = props
  const [formOpen, openForm, closeForm] = useBoolean()

  const {t} = useResourceTranslation('channels')

  //------
  // Rendering

  function render() {
    return (
      <SummaryInfo.Item
        icon='headset'
        bold={channel.moderation != null}
        summary={t(`moderation.summary.${channel.moderation != null ? 'enabled' : 'disabled'}`)}
        body={renderModerationGroup()}
        requestEdit={openForm}
      >
        <ChannelModerationForm
          open={formOpen}
          requestClose={closeForm}
          channel={channel}
        />
      </SummaryInfo.Item>
    )
  }

  function renderModerationGroup() {
    if (channel.moderation == null) { return null }

    return (
      <VBox gap={layout.padding.inline.m}>
        <Label small dim>
          {t('moderation.group')}
        </Label>
        <ResourceChipRow
          Model={Group}
          ids={[channel.moderation.moderatorGroup]}
          small
        />
      </VBox>
    )
  }

  return render()

})

export default ChannelModeration